import { supabase } from '../lib/supabase';
import { getCurrentOrgId } from '../lib/getCurrentOrgId';

/**
 * Fetch all notes for a project, ordered newest first.
 * RLS ensures only notes from the current user's org are returned.
 */
export async function getByProject(projectId) {
  const { data, error } = await supabase
    ?.from('project_notes')
    ?.select('*')
    ?.eq('project_id', projectId)
    ?.order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
}

/**
 * Insert a new note for a specific card.
 * @param {{ projectId: string, cardKey: string, note: string }} params
 * @param {{ id: string, full_name: string }} userProfile
 */
export async function addNote({ projectId, cardKey, note }, userProfile) {
  const organizationId = await getCurrentOrgId();

  const { data, error } = await supabase
    ?.from('project_notes')
    ?.insert({
      organization_id: organizationId,
      project_id: projectId,
      card_key: cardKey,
      note,
      created_by: userProfile?.id,
      author_name: userProfile?.full_name || null,
    })
    ?.select()
    ?.single();

  if (error) throw error;
  return data;
}

/**
 * Delete a note by id. RLS allows only the author to delete their own notes.
 */
export async function deleteNote(id) {
  const { error } = await supabase
    ?.from('project_notes')
    ?.delete()
    ?.eq('id', id);

  if (error) throw error;
}

function projectNotesService(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: projectNotesService is not implemented yet.', args);
  return null;
}

export default projectNotesService;